/*
 * Módulo de frontend: página "Menciones" (hilos de Discord relevantes por usuario).
 */
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import ForumIcon from '@material-ui/icons/Forum';

const discordPage = PageBlueprint.make({
  name: 'discord',
  params: {
    path: '/menciones',
    title: 'Menciones',
    icon: <ForumIcon />,
    loader: () => import('./DiscordPage').then(m => <m.DiscordPage />),
  },
});

export const discordModule = createFrontendModule({
  pluginId: 'app',
  extensions: [discordPage],
});
